// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"LossDetailsProperty_pageContainer__2yvBB"};